import { render, staticRenderFns } from "./infoAlert.vue?vue&type=template&id=61841ba2&scoped=true&"
import script from "./infoAlert.vue?vue&type=script&lang=js&"
export * from "./infoAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61841ba2",
  null
  
)

export default component.exports